import { ContactUs } from '@parkingbase/ecommerce-api-dev';

import { create } from 'zustand';
import { ContactUsService } from '@/services/contact-us.service';
import { logger } from '@/lib/logger';

const contactUsService = new ContactUsService();

interface ContactUsState {
  contactUs: ContactUs | null;
  isLoading: boolean;
  fetchContactUs: () => Promise<void>;
}

export const useContactUsStore = create<ContactUsState>((set) => ({
  contactUs: null,
  isLoading: false,

  fetchContactUs: async () => {
    set({ isLoading: true });
    try {
      const contactUs = await contactUsService.getDefaultContactUs();
      set({ contactUs });
    } catch (error) {
      logger.error('Failed to fetch contact us config', error, {
        feature: 'contact-us-store',
        route: 'fetchContactUs',
      });
    } finally {
      set({ isLoading: false });
    }
  },
}));
